import type { FaireProductEntity } from "../../entity_types/product";

export const p_tzuyzvvefa: FaireProductEntity = {
  token: "p_tzuyzvvefa",
  type: "product",
  name: "Handpicked by God Strawberries Youth Faith Graphic Tee",
  brandToken: "b_crntsyfkzr",
  brandName: "J. Mack Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/ae2a3d7ced57342220bfa56289e3538a19bb24ed3f0f4d0fc2034ac3485b523c.png",
  galleryImageUrls: [],
  priceDollars: 13.5,
  description:
    "This design comes printed on a unisex youth tee. These run true to size and are on a super soft Bella Canvas brand tee.\n\nDetails:\n- Printed in Florida\n- Brand: Bella Canvas\n- Color: Pink\n- Fit: Unisex\n- Material: 100% cotton\n\nThis graphic tee is part of our spring/summer '25 collection.\n\nFaith * Christian * Inspirational * Jesus * Religious * Summer * God * Strawberry",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:30.053Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
